var _global = (typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {}); _global.SENTRY_RELEASE={id:"c2aa9685ad1b10cf805dd389078e344dab86336f"};
      _global.SENTRY_RELEASES=_global.SENTRY_RELEASES || {};
      _global.SENTRY_RELEASES["app@coordinape"]={id:"c2aa9685ad1b10cf805dd389078e344dab86336f"};
      